export default __webpack_public_path__ + "static/media/calendar-filled.a5dbfcd1.svg";